<div [ngClass]="dumpster?.parentDumpsterId || dumpster.childDumpsterId ? 'template-wrapper' : 'w-100'">
  <a (click)="setFieldClick()" class="mr-2">{{ dumpster?.code }}</a>
  <app-relation-icon
    [dumpster]="dumpster"
  ></app-relation-icon>
</div>
